import { render, staticRenderFns } from "./UPCCodesImport.vue?vue&type=template&id=6d071e32&scoped=true"
import script from "./UPCCodesImport.vue?vue&type=script&lang=js"
export * from "./UPCCodesImport.vue?vue&type=script&lang=js"
import style0 from "./UPCCodesImport.vue?vue&type=style&index=0&id=6d071e32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d071e32",
  null
  
)

export default component.exports